module.exports = __webpack_public_path__ + "static/021.thumb-87fb5a0234c2cef85187f221f6a94755.jpg";